/* eslint-disable no-shadow */
import { useMemo, useCallback } from 'react'
import {
  mapFptiOptions,
  trackActivityEvent,
  trackClickEvent,
} from '../utils/analytics/fpti-helper'
import serverData from '../utils/server-data'
import { isRenderingOnServer } from '../utils/helper'
import { fptiTypes } from '../utils/analytics/fpti-constants'

const mapBaseOptions = (options) => {
  if (isRenderingOnServer()) {
    return {}
  }

  const { pageProps } = serverData
  const { pageName } = pageProps

  const baseOptions = {
    ...options,
    pgrp: `main:help:center:${pageName}`,
    comp: 'helpcenternodeweb',
    pageName,
  }

  return baseOptions
}

// hook-based, memoized FPTI tracker for functional components
const useTracking = (options) => {
  const mappedBaseOptions = useMemo(() => {
    return mapBaseOptions(options)
  }, [])

  const trackClick = useCallback(
    (options) => {
      const mergedOptions = {
        ...mapFptiOptions(options, mappedBaseOptions),
      }

      trackClickEvent(mergedOptions)
    },
    [mappedBaseOptions],
  )

  const trackActivity = useCallback(
    (options) => {
      const mergedOptions = {
        ...mapFptiOptions(options, mappedBaseOptions),
      }

      trackActivityEvent(mergedOptions)
    },
    [mappedBaseOptions],
  )

  const fptiTypeByStatusCode = useCallback(
    (statusCode) => {
      if (statusCode) {
        if (statusCode === 404) {
          return fptiTypes.NO_DATA
        }

        if (statusCode === 400) {
          return fptiTypes.VALIDATION_ERROR
        }

        if (statusCode === 200) {
          return fptiTypes.SUCCESS
        }

        if (statusCode >= 500) {
          return fptiTypes.SERVICE_ERROR
        }
      }
      return fptiTypes.ERROR
    },
    [mappedBaseOptions],
  )

  return {
    trackClick,
    trackActivity,
    fptiTypeByStatusCode,
  }
}

// non-hook-based FPTI tracker for class components
// TODO: Still under work
export const fpti = (componentOptions) => {
  const mappedComponentOptions = mapBaseOptions(componentOptions)

  const fptiClick = (options) => {
    const mergedOptions = {
      ...mapBaseOptions(options),
      ...mappedComponentOptions,
    }
    trackActivityEvent(mergedOptions, mappedComponentOptions)
  }

  return {
    fptiClick,
  }
}

export default useTracking
